import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { isUndefined } from "lodash";

import i18n from "../i18n";
import { fetchToken } from "../api/apiRefreshToken";
import apiHelper from "../api/apiHelper";

import { InitialState } from "../interfaces/reducer.interface";
import { APIResult } from "../interfaces/response.interface";
import { SafeZone } from "../interfaces/safeZone.interface";

import { Key } from "../enums/localStorageEnum";
import { MultiLang } from "../enums/multiLangEnum";

import { setDefaultValue } from "../slices/loadingSlice";

export const fetchSafeZoneUser = createAsyncThunk(
  "safeZone/fetchSafeZoneUser",
  async (data: any, { rejectWithValue, dispatch }) => {
    const { PageSize, PageNum, deviceGUID }: SafeZone = data;
    try {
      await fetchToken();
      apiHelper.setHeader({
        Authorization: localStorage.getItem(Key.Token),
        "Accept-Language": i18n.language === MultiLang.EN ? "en-US" : "ja-JP",
      });

      const response = await apiHelper
        .handleRequest({
          method: "GET",
          url: `api/SafeZoneUser`,
          params: {
            DeviceGUID: deviceGUID,
          },
        })
        .then((res) => res.data);
      dispatch(setDefaultValue({ isLoading: false }));
      return response;
    } catch (err: any) {
      dispatch(setDefaultValue({ isLoading: false }));
      let result = err.response.data as APIResult;
      if (isUndefined(result.Message)) {
        toast.error(result.title);
      } else {
        toast.error(result.Message);
      }
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const initialState: InitialState<SafeZone> = {
  entities: [],
  loading: "idle",
  saving: "idle",
  currentRequestId: null,
  error: null,
};

const safeZoneUserSlice = createSlice({
  name: "safeZoneUsers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSafeZoneUser.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
        }
      })
      .addCase(fetchSafeZoneUser.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          const { Data, PageNum, PageSize, Total }: APIResult = action.payload;
          state.loading = "idle";
          state.entities = Data ?? [];
          state.currentRequestId = undefined;
        }
      })
      .addCase(fetchSafeZoneUser.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error = action.error;
          state.currentRequestId = undefined;
        }
      });
  },
});

export default safeZoneUserSlice.reducer;
